import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.sectionTitleColour};
  border-radius: 2px;
  font-size: 0.8125rem;
  line-height: 1.3;
  color: ${({ theme }) => theme.sectionTitleColour};
`;
